import { render, staticRenderFns } from "./LoyaltyPromotionDescription.vue?vue&type=template&id=677e7e28&scoped=true&lang=pug"
import script from "./LoyaltyPromotionDescription.vue?vue&type=script&lang=ts"
export * from "./LoyaltyPromotionDescription.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyPromotionDescription.vue?vue&type=style&index=0&id=677e7e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e7e28",
  null
  
)

export default component.exports